import striptags from 'striptags';
import { WidgetType } from '../models/pages';

function hasSeoContent(component:any) {
  return (component.internal.type === WidgetType.Bus);
}
export function formatSeoDescription(contentfulDescription:any) {
  if (contentfulDescription) {
    const description = striptags(contentfulDescription);
    if (description.length <= 160) {
      return description;
    }
    const lastPeriodIndex = description.slice(0, 160).lastIndexOf('.');
    if (lastPeriodIndex > 150) {
      return description.slice(0, lastPeriodIndex + 1);
    }
    return `${description.slice(0, 157)}...`;
  }
  return '';
}

export function getSeoVideoAttributes(
  widgets:any,
  stringTranslations: any,
) {
  if (widgets?.some(hasSeoContent)) {
    let seoDescription;
    let seoImage;
    widgets.forEach((w:any) => {
      switch (w.internal.type) {
        case WidgetType.Bus:
          seoImage = w.seoImage.url;
          seoDescription = formatSeoDescription(stringTranslations['bus-page-description'].en) || '';
          break;
        default:
          seoDescription = '';
          seoImage = '';
      }
    });
    return [seoImage, seoDescription];
  }
  return ['', ''];
}
